import { createSlice } from "@reduxjs/toolkit";
import { FileStorageDTO } from "../../models/FileStorage.model";
import {
  getFileStorage,
  updateFileStorage,
  deleteFileStorage,
} from "../thunks/fileStorageThunks";

interface FileStorageState {
  files: FileStorageDTO[];
  loading: boolean;
  error: string | null;
  uploadLoading: boolean;
  deleteLoading: boolean;
}

const initialState: FileStorageState = {
  files: [],
  loading: false,
  error: null,
  uploadLoading: false,
  deleteLoading: false,
};

const fileStorageSlice = createSlice({
  name: "fileStorage",
  initialState,
  reducers: {
    clearFileStorageError(state) {
      state.error = null;
    },
    clearFileStorage(state) {
      state.files = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // -------------------- getFileStorage --------------------
      .addCase(getFileStorage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFileStorage.fulfilled, (state, action) => {
        state.loading = false;
        state.files = action.payload.fileStorages || [];
      })
      .addCase(getFileStorage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "שגיאה בשליפת קבצים";
      })

      // -------------------- updateFileStorage --------------------
      .addCase(updateFileStorage.pending, (state) => {
        state.uploadLoading = true;
        state.error = null;
      })
      .addCase(updateFileStorage.fulfilled, (state) => {
        state.uploadLoading = false;
        // נרענן את הרשימה — הקומפוננטה תקרא ל-getFileStorage
      })
      .addCase(updateFileStorage.rejected, (state, action) => {
        state.uploadLoading = false;
        state.error = action.payload || "שגיאה בהעלאת קובץ";
      })

      // -------------------- deleteFileStorage --------------------
      .addCase(deleteFileStorage.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deleteFileStorage.fulfilled, (state, action) => {
        state.deleteLoading = false;
        // הסרת הקובץ מהרשימה המקומית (אופטימי)
        const deletedId = action.meta.arg.fileStorageID;
        state.files = state.files.filter(
          (f) => f.fileStorage_ID !== deletedId,
        );
      })
      .addCase(deleteFileStorage.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload || "שגיאה במחיקת קובץ";
      });
  },
});

export const { clearFileStorageError, clearFileStorage } =
  fileStorageSlice.actions;
export default fileStorageSlice.reducer;
